import React, {Component, PropTypes} from 'react';

import {DatePicker} from 'material-ui';
import moment from 'moment';

class FrequencyStartingFrom extends Component {

  static getLabel = (filter) => {
    return moment(filter.value).format('D MMM YYYY').toString();
  }

  getDateObject = (dateString) => {
    return dateString ? new Date(dateString) : {};
  };

  disableDate = (date) => {
    const today = new Date();
    let yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);

    return (date < yesterday);
  };


  formatDate = (date) => {
    return moment(date).format('D MMM YYYY').toString();
  }

  setStartingDate = (e, date)=> {
    this.props.action({
      value: moment(date).format('YYYY-MM-DD'),
      label: FrequencyStartingFrom.getLabel({value: date})
    });
  }

  openDatePicker = (datePicker) => {
    this.refs[datePicker].openDialog();
  }

  render() {

    return (

      <section>
        <div className="form-row">
          <DatePicker
            className="date-picker"
            name="start"
            ref="start"
            value={this.getDateObject(this.props.filter.value)}
            formatDate={this.formatDate}
            onChange={this.setStartingDate}
            hintText="Select date"
            shouldDisableDate={this.disableDate}
            fullWidth
          />
          <i className="icon icon-calendar icon-size-20 icon-secondary" onClick={() => this.openDatePicker('start')}/>
        </div>
      </section>
    );
  }
}

FrequencyStartingFrom.propTypes = {
  action: PropTypes.func,
  filter: PropTypes.object.isRequired,
  countries: PropTypes.array
};

export default FrequencyStartingFrom; 



// WEBPACK FOOTER //
// ./src/features/scheduling-reports/report-edit/components/frequency/FrequencyStartingFrom.js